<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap align-center justify-center>
      <v-flex md6 sm12 lg6>
        <material-card class="elevation-12">
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-form ref="form" v-model="loginForm.isValid" lazy-validation>
              <v-container fluid>
                <v-layout wrap>
                  <v-flex md12 sm12 lg12>
                    <v-text-field
                  v-model="input.email"
                  label="Email"
                  filled
                  required
                ></v-text-field>
                  </v-flex>
                  <v-flex md12 sm12 lg12>
                    <v-text-field
                  v-model="input.password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  label="Password"
                  class="input-group--focused"
                  autocomplete="on"
                  @click:append="showPassword = !showPassword"
                  filled
                  required
                ></v-text-field>
                  </v-flex>
                  <v-flex md12 sm12 lg12>
                    <v-btn color="primary" @click="login()">Login</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'login',
  data: () => ({
    showPassword: false,
    loginForm: {
      isValid: false
    },
    input: {
      email: '',
      password: ''
    }
  }),
  computed: {
    loggedIn () {
      return this.$store.state.auth.loggedIn
    }
  },
  methods: {
    login () {
      if (this.$refs.form.validate()) {
        const formData = new FormData()
        formData.append('username', this.input.email)
        formData.append('password', this.input.password)
        this.$store.dispatch('auth/login', formData)
      }
    }
  },
  mounted () {
    if (this.loggedIn) {
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>
